import { useState } from "react"
import { Button } from "@/components/ui/button"
import { hinEpdLogin, hinEpdLogout } from "@/lib/hin-epd-login"
import { hinLogin, hinLogout } from "@/lib/hin-login"
import { cn } from "@/lib/utils"
import { DummyConnectVideoCallDialog } from "@/modules/video-call/components/dummy-call/dummy-connect-video-call-dialog"

interface HeaderProps extends React.HTMLAttributes<HTMLElement> {
  title?: string
}

const Header = ({ className, title, children }: HeaderProps) => {
  const [openDummyVideoCall, setOpenDummyVideoCall] = useState<boolean>(false)

  return (
    <header className={cn("border-border bg-surface h-16 border-b", className)}>
      <div className="flex h-full items-center justify-between px-8 py-3">
        <div className="animate-fade-in-left flex items-center gap-2">
          <h1 className="text-xl font-bold" data-testid="page-title">
            {title}
          </h1>
          <div className="animate-fade-in-left hidden items-center gap-2 xl:flex">
            <div className={cn("flex gap-2", "opacity-100")}>
              <Button
                variant="circle"
                title="Start HIN Sign Login flow"
                className="bg-developer-tool-surface hover:bg-developer-tool-surface h-10 w-32 opacity-0 transition-opacity duration-200 ease-in hover:opacity-100"
                onClick={hinLogin}>
                HIN Sign Login
              </Button>
            </div>
          </div>
          <div className="animate-fade-in-left hidden items-center gap-2 xl:flex">
            <div className={cn("flex gap-2", "opacity-100")}>
              <Button
                variant="circle"
                title="Try HIN Sign Logout"
                className="bg-developer-tool-surface hover:bg-developer-tool-surface h-10 w-32 opacity-0 transition-opacity duration-200 ease-in hover:opacity-100"
                onClick={hinLogout}>
                HIN Sign Logout
              </Button>
            </div>
          </div>
          <div className="animate-fade-in-left hidden items-center gap-2 xl:flex">
            <div className={cn("flex gap-2", "opacity-100")}>
              <Button
                variant="circle"
                title="Start HIN E-Rezept Login flow"
                className="bg-developer-tool-surface hover:bg-developer-tool-surface h-10 w-32 opacity-0 transition-opacity duration-200 ease-in hover:opacity-100"
                onClick={hinEpdLogin}>
                HIN E-Rezept Login
              </Button>
            </div>
          </div>
          <div className="animate-fade-in-left hidden items-center gap-2 xl:flex">
            <div className={cn("flex gap-2", "opacity-100")}>
              <Button
                variant="circle"
                title="Try HIN E-Rezept logout"
                className="bg-developer-tool-surface hover:bg-developer-tool-surface h-10 w-32 opacity-0 transition-opacity duration-200 ease-in hover:opacity-100"
                onClick={hinEpdLogout}>
                HIN E-Rezept Logout
              </Button>
            </div>
          </div>
          <div className="animate-fade-in-left flex items-center gap-2">
            <div className={cn("flex gap-2", "opacity-100")}>
              <Button
                variant="circle"
                title="Video call"
                className="bg-developer-tool-surface hover:bg-developer-tool-surface h-10 w-32 opacity-0 transition-opacity duration-200 ease-in hover:opacity-100"
                onClick={() => setOpenDummyVideoCall(true)}>
                Video call
              </Button>
            </div>
          </div>
        </div>
        {children}
      </div>
      {openDummyVideoCall && (
        <DummyConnectVideoCallDialog open={openDummyVideoCall} onOpenChange={setOpenDummyVideoCall} />
      )}
    </header>
  )
}

export { Header }
